// Order matters. Used for determining where to insert empty table groups during export
export enum TableGroupType {
  Table = 'table',
  THeader = 'thead',
  TBody = 'tbody',
  TRow = 'tr',
  TFooter = 'tfoot'
}
